export default function GlossaryTermsHeader() {

    // BUILD
    return (
        <div className={"mt-[16px] w-full h-[56px] min-h-[56px] bg-backgroundLight5 grid grid-cols-[minmax(120px,2fr)_minmax(240px,6fr)_minmax(100px,120px)] gap-[16px] items-center px-[24px] text-[12px] text-greyLight7 font-medium"}>
            <div className={"min-w-0 flex justify-start"}>
                <span className={"font-bold text-[14px] text-white truncate"}>
                    {"Terme"}
                </span>
            </div>

            <div className={"min-w-0 flex justify-start"}>
                <span className={"font-bold text-[14px] text-white truncate"}>
                    {"Définition"}
                </span>
            </div>

            <div className={"min-w-0 flex justify-end"}>
                <span className={"font-bold text-[14px] text-white whitespace-nowrap"}>
                    {"Action"}
                </span>
            </div>
        </div>
    );
}